<button mat-icon-button type="button" [matMenuTriggerFor]="messagingMenu" aria-label="Open message notifications"
    [matBadge]="(totalUnreadMessages$ | async) || 0" [matBadgeHidden]="((totalUnreadMessages$ | async) || 0) === 0"
    matBadgeColor="warn" matBadgeSize="medium">
    <mat-icon>mail</mat-icon>
</button>

<mat-menu #messagingMenu="matMenu" class="messaging-menu">
    <div class="menu-header" mat-menu-item disabled>
        <span>Message notifications</span>
    </div>

    @if (previewNotifications$ | async; as notifications) {
    @if (notifications.length) {
    @for (notification of notifications; track notification.notificationId) {
    <button mat-menu-item type="button" class="thread-item" (click)="openNotification(notification)">
        <div class="thread-item-text">
            <strong>{{ notification.type || 'Notification' }}</strong>
            <small class="sender-line">{{ notification.sender?.display || 'Unknown' }}</small>
            <span>{{ notification.preview }}</span>
            @if (notification.contextType || notification.contextId) {
            <small class="context-line">{{ notification.contextType }} {{ notification.contextId }}</small>
            }
            <small>{{ notification.createdAt | date:'short' }}</small>
        </div>

        @if (notification.status !== 'read') {
        <span class="thread-unread-chip">!</span>
        }
    </button>
    }
    } @else {
    <div class="empty-state" mat-menu-item disabled>
        <span>No message notifications yet.</span>
    </div>
    }
    }

    <mat-divider></mat-divider>

    <div class="menu-actions">
        <button mat-menu-item type="button" (click)="openInbox()">
            <mat-icon>forum</mat-icon>
            <span>All messages</span>
        </button>

        @if (latestNotification$ | async; as latestNotification) {
        <button mat-menu-item type="button" (click)="openLatestNotificationFromValue(latestNotification)">
            <mat-icon>north_east</mat-icon>
            <span>Latest notification</span>
        </button>
        } @else {
        <button mat-menu-item type="button" (click)="openInbox()">
            <mat-icon>north_east</mat-icon>
            <span>Latest notification</span>
        </button>
        }
    </div>
</mat-menu>